<template>
  <div class="event-profile">
    <event-detail-title :type="anchorMap.PROFILE_KEY"></event-detail-title>
    <div class="section-content">
      <markdown-beautiful :data="events_profile_html"></markdown-beautiful>
      <div class="section-keyinfos">
        <div class="section-keyinfo" v-if="begin_time&&end_time">
          <div class="section-icon iconfont icon-shijian"></div>
          <div class="section-value">{{`${formatTime(begin_time)}开始 至 ${formatTime(end_time)}结束`}}</div>
        </div>
        <div class="section-keyinfo">
          <div class="section-icon iconfont icon-chengshi"></div>
          <div class="section-value">
            <span v-if="countryMap[country]">{{countryMap[country]}}</span>
            <span v-if="_province&&Number(country)!==2">{{_province.name}}</span>
            <span v-if="city.name">{{city.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { areaData } from '@/config'
import eventDetailTitle from './event-detail-title'
import markdownBeautiful from '@/components/markdown-beautiful'
import { anchorMap } from './utils'
import vueTypes from 'vue-types'
export default {
  name: 'event-detail-profile',
  data () {
    return {
      countryMap: {
        '1': '中国',
        '2': '美国'
      },
      anchorMap,
      areaData
    }
  },
  components: {
    eventDetailTitle,
    markdownBeautiful
  },
  props: {
    events_profile_html: vueTypes.string.isRequired,
    begin_time: vueTypes.number.isRequired,
    end_time: vueTypes.number.isRequired,
    country: vueTypes.number.isRequired,
    province: vueTypes.number.isRequired
  },
  computed: {
    _province () {
      if (Number(this.province) === 0) {
        return this.areaData['86'].filter(item => item.cid === Number(this.country))[0] || { 'name': '', 'id': '' }
      } else {
        return this.areaData['86'].filter(item => item.cid === Number(this.country) && item.id === Number(this.province))[0] || { 'name': '', 'id': '' }
      }
    },
    city () {
      if (this.areaData[this.province.id]) {
        return this.areaData[this.province.id].childs.filter(item => item.id === Number(this.city))[0] || { 'name': '' }
      } else {
        return { 'name': '' }
      }
    }
  },
  methods: {
    formatTime (time) {
      return moment(Number(time) * 1000).format('YYYY年M月D日 H:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

.event-profile {
  margin-bottom: 30px;
}

.section-content {
  line-height: 32px;
  color: #4A4A4A;

  .section-keyinfos{
    background-color: rgba(215, 179, 117, .13);
    padding: 16px 17px;

    .section-keyinfo {
      display: flex;
      align-items: center;

      .section-icon{
        font-size: 14px;
        margin-right: 15px;
        color: $primary3;
        &.icon-dizhi{
          font-size: 16px;
        }
      }
    }
  }
}
</style>
